export default __webpack_public_path__ + "d15f9d46b1d350607109586f076eace7.png";